export const useTagSelect = ({
  value,
  onChange
}: {
  value: string[]
  onChange: (selected: string[]) => void
}) => {
  const handleSelect = (newVal: string) => {
    onChange([...value, newVal])
  }
  const handleRemove = (val: string) => {
    onChange(value.filter((v) => v !== val))
  }

  return { selected: value || [], handleSelect, handleRemove }
}
